import type { ReactNode } from "react";

// 各画面の冒頭に置く使い方パネル。
// 初見の営業でも迷わないように、手順を画面内に置いておく（別資料を開かせない）。
// 既定は閉じた状態。一度読めば邪魔なので、開閉は details に任せる。
export function HowTo({
  title = "この画面の使い方",
  defaultOpen = false,
  children,
}: {
  title?: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  return (
    <details
      open={defaultOpen}
      className="bg-white ring-1 ring-ink/10 [&[open]>summary]:border-b [&[open]>summary]:border-ink/10"
    >
      <summary className="cursor-pointer select-none px-5 py-3 text-sm font-medium marker:content-['']">
        <span className="text-ink-muted">?</span> {title}
      </summary>
      <div className="px-5 py-4 text-sm leading-relaxed text-ink-muted [&_b]:text-ink [&_code]:bg-ink/[0.06] [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-xs">
        {children}
      </div>
    </details>
  );
}

// 手順の1ステップ。番号を丸で出す。
export function HowToStep({ n, children }: { n: number; children: ReactNode }) {
  return (
    <li className="flex gap-3">
      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ink text-[11px] font-medium text-white">
        {n}
      </span>
      <span className="flex-1">{children}</span>
    </li>
  );
}
